import { Component, OnDestroy, AfterViewInit, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TINYMCE_FONT_STYLE, TINYMCE_BASE_BODY_STYLE } from '../../constants/tinymce-content-style';
import 'tinymce/tinymce.min';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/lists';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/models/dom';

declare let tinymce: any;

/**
 * Lightweight rich text editor for basic formatting (bold, italic, underline, headings, lists).
 * No image upload, tables, colors, or advanced features.
 */
@Component({
    selector: 'rms-simple-rich-text-editor',
    template: `<textarea id="{{elementId}}">{{content}}</textarea>`,
    styleUrls: ['./rms-simple-rich-text-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RmsSimpleRichTextEditorComponent implements OnDestroy, AfterViewInit {
  @Input() elementId: string;
  @Input() content: string;
  @Output() onEditorChange = new EventEmitter<string>();

  public editor: any;

  ngAfterViewInit(): void {
    tinymce.init({
      license_key: 'gpl',
      selector: `#${this.elementId}`,
      branding: false,
      content_style: `${TINYMCE_FONT_STYLE} ${TINYMCE_BASE_BODY_STYLE} p { margin: 0 0 0.5rem 0; }`,
      plugins: 'autoresize lists',
      resize: true,
      browser_spellcheck: true,
      contextmenu: false,
      toolbar: 'undo redo | blocks | bold italic underline strikethrough | bullist numlist outdent indent',
      menubar: false,
      statusbar: false,
      promotion: false,
      min_height: 150,
      skin_url: '../../../assets/third-parties/tinymce/skins/oxide',
      content_css: '../../../assets/third-parties/tinymce/skins/oxide/content.min.css',
      setup: editor => {
        this.editor = editor;
        editor.on('init', () => {
          this.content = this.content || '';
          editor.setContent(this.content);
          editor.focus();
        });
        editor.on('Change', () => {
          this.onEditorChange.emit(editor.getContent());
        });
        editor.on('keyup', () => {
          this.onEditorChange.emit(editor.getContent());
        });
      }
    });
  }

  ngOnDestroy(): void {
    tinymce.remove(this.editor);
  }
}
